import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import {
    Card,
    CardBody,
    Input,
} from "reactstrap"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import EmployeeLeaveTable from "./EmployeeLeaveTable"
import DeleteModel from "common/deleteModel/deleteModel"
import { exportDataExcel } from "components/Common/ExportData"
import { dateFormat } from "pages/Common"
import ErrorModel from "common/errorModel/errorModel"
import { GetObjByEmployeeLeaveStatus } from "_mock/Static_data"
import EmployeeLeaveModal from "./EmployeeLeaveModal"

function EmployeeLeave() {
    document.title = `Employee Leave | Raja Rani Couture`
    let { pathname } = useLocation()
    const { deleteApi, getApi, postApi, putApi } = useApi()
    // useStates
    const [isEdit, setIsEdit] = useState(false)
    const [editData, setEditData] = useState(null)
    const [tableData, setTableData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [screenLoad, setScreenLoad] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [isMobile, setisMobile] = useState(window.innerWidth < 768)
    const [displayStart, setDisplayStart] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [userFilter, setUserFilter] = useState(0)
    const [users, setUsers] = useState([])
    const [dateFilter, setDateFilter] = useState([new Date(), new Date()])
    const [dateDisble, setdateDisble] = useState(true)
    const [totalRecords, setTotalRecords] = useState(0)
    const [statusFilter, setStatusFilter] = useState(0)
    const [TaskTitleTypes, setTaskTitleTypes] = useState(
        (JSON.parse(localStorage?.getItem("authUser")).TaskTitleTypes)
    )
    const [employeeLeaveModal, setEmployeeLeaveModal] = useState(false);
    const [userId, setUserId] = useState(JSON.parse(localStorage?.getItem("authUser")).Id);

    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setRowsPerPage(pageSize)
    }

    useEffect(() => {
        getApi('Attendance/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                setUsers(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [])

    // user list api
    const EmpLeaveListApi = () => {
        setIsLoading(true)
        setScreenLoad(true)
        postApi("Attendance/emp-leave-list", {
            fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                dateFilter[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                dateFilter[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            AttendanceUserId: (JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" || JSON.parse(localStorage.getItem("authUser")).RoleName == "Master") ? parseInt(userFilter) : JSON.parse(localStorage?.getItem("authUser")).AttendanceUserId,
            Status: parseInt(statusFilter),
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "asc",
        }).then(({ data, status }) => {
            if (status === 200) {
                setTableData(data?.EmpLeaveList)
                setTotalRecords(data?.TotalRecords)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            setScreenLoad(false)
        })
    }

    // user list api useEffect
    useEffect(() => {
        if (dateFilter[1] != undefined) {
            EmpLeaveListApi()
        }
    }, [searchText, displayStart, rowsPerPage, userFilter, dateFilter, dateDisble, statusFilter])

    // Delete user handler
    const handleDelete = Id => {
        setScreenLoad(true)
        if (Id) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this record permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`Attendance/emp-leave-delete?id=${Id}`).then(
                        async ({ data, status }) => {
                            if (status === 200) {
                                const updatedArray = tableData
                                    .map(obj => (obj.Id !== Id ? obj : null))
                                    .filter(Boolean)
                                setTableData(updatedArray)
                                toast.success("Sucessfully deleted", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Attendence",
                                    text: data,
                                })
                            }
                            setScreenLoad(false)
                        }
                    )
                } else {
                    setScreenLoad(false)
                }
            })
        }
    }

    // Update user handler
    const handleEditCustomer = customerData => {
        if (customerData) {
            setEditData(customerData)
            setIsEdit(true)
            employeeLeaveToggle()
        }
    }

    const employeeLeaveToggle = () => {
        setEmployeeLeaveModal(!employeeLeaveModal)
    }

    // Create user handler
    const handleCreateUpdateEmployeeLeave = () => {
        setIsEdit(false)
        setEditData('')
        employeeLeaveToggle()
    }

    const handleStatusChange = (data, status) => {
        DeleteModel.confirmDeleteInquiry({
            title: "Are you sure? ",
            text: "You want to change this status? ",
            isMobile,
        }).then(response => {
            if (response == true) {
                putApi("Attendance/leave-status-change", {
                    Id: data.Id,
                    Status: parseInt(status),
                }).then(({ data, status }) => {
                    if (status == 200) {
                        EmpLeaveListApi()
                        toast.success("successfully updated", {
                            style: {
                                fontSize: "15px",
                            },
                        })
                    } else {
                        toast.error(data, {
                            style: {
                                fontSize: "15px",
                            },
                        })
                    }
                })
            } else {
                setIsLoading(false)
            }
        })
    }

    // table headers & accessor
    const columns = useMemo(
        () => [
            {
                Header: "Name",
                accessor: "Name",
            },
            {
                Header: "FullDay",
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Full Day
                    </div>
                ),
                accessor: "IsFullDay",
                width: "8%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center"
                        }}>
                            {row?.original?.IsFullDay ? 'YES' : "NO"}
                        </div>
                    )
                },
            },
            {
                Header: "Leave Hours",
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Leave Hours
                    </div>
                ),
                accessor: "LeaveHours",
                width: "8%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center"
                        }}>
                            {row?.original?.LeaveHours > 0 ? (row?.original?.LeaveHours) : "0:00"}
                        </div>
                    )
                },
            },
            {
                Header: "From Date",
                accessor: "FromDate",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original?.FromDate == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row.original?.FromDate?.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: "To Date",
                accessor: "ToDate",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original?.ToDate == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row.original?.ToDate?.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: "Remarks",
                accessor: "Remarks",
                // width: "15%",
                Cell: ({ row }) => {
                    return (
                        <div>
                            {row.original.Remarks ? row.original.Remarks : "N/A"}
                        </div>
                    )
                },
            },
            {
                Header: "Status",
                accessor: "Status",
                width: "10%",
                Cell: ({ row }) => (
                    <div>
                        {TaskTitleTypes == null ?
                            <>
                                <Input
                                    disabled={row.original.Status == 2 || row.original.Status == 3}
                                    type="select"
                                    bsSize="sm"
                                    id="validationCustom01"
                                    className="form-control-sm"
                                    style={{ width: "110px" }}
                                    onChange={e => {
                                        handleStatusChange(row.original, e.target.value)
                                    }}
                                    value={row.original.Status}
                                >
                                    {row.original.Status == 1 ?
                                        <>
                                            {GetObjByEmployeeLeaveStatus(1, 2, 3).map((item, index) => {
                                                return (
                                                    <option key={index} value={item.Value}>
                                                        {item.Key}
                                                    </option>
                                                )
                                            })}
                                        </>
                                        :
                                        row.original.Status == 2 ?
                                            <>
                                                {GetObjByEmployeeLeaveStatus(2, 3).map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.Value}>
                                                            {item.Key}
                                                        </option>
                                                    )
                                                })}
                                            </>
                                            :
                                            <>
                                                {GetObjByEmployeeLeaveStatus(3).map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.Value}>
                                                            {item.Key}
                                                        </option>
                                                    )
                                                })}
                                            </>
                                    }

                                </Input>
                            </>
                            :
                            <>
                                {GetObjByEmployeeLeaveStatus(row.original.Status)[0].Key}
                            </>
                        }
                    </div>
                )
            },
            {
                Header: "Created On",
                accessor: "CreatedOn",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original?.CreatedOn == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row.original?.CreatedOn?.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: "Action",
                width: "6%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                            {row.original.Status > 1 ?
                                <>
                                    <li className="mytooltip">
                                        <i
                                            className={`fs-6 fas fa-edit`}
                                            style={{ cursor: "not-allowed", color: "#808080b3" }}
                                        ></i>
                                        <span className="mytext">Edit</span>
                                    </li>
                                    <li className="mytooltip">
                                        <i
                                            className={`fs-6 fas fa-trash-alt btn-delete`}
                                            style={{ cursor: "not-allowed", color: "#808080b3" }}
                                        ></i>
                                        <span className="mytext">Delete</span>
                                    </li>
                                </>
                                :
                                <>

                                    <li className="mytooltip">
                                        <i
                                            className=" fs-6 fas fa-edit btn-edit"
                                            id={`edittooltip${row.original.Id}`}
                                            onClick={() => handleEditCustomer(row.original)}
                                        ></i>
                                        <span className="mytext">Edit</span>
                                    </li>
                                    <li className="mytooltip">
                                        <i
                                            className="fs-6 fas fa-trash-alt btn-delete"
                                            id={`deletetooltip${row.original.Id}`}
                                            onClick={() => handleDelete(row.original.Id)}
                                        ></i>
                                        <span className="mytext">Delete</span>
                                    </li>
                                </>
                            }
                        </ul>
                    )
                },
            },
        ],
        [tableData]
    )

    function writeDataToExcel() {
        if (!dateDisble) {
            toast.error("Please Select date", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        } else {
            setIsLoading(true)
            let header = ["Name", "Full Day", "Leave Hours", "From Date", "To Date", "Remarks", "Status", "Created On"];
            const mainTitle = "Emaployee Leaves";
            const widthObj = [{
                Key: "A",
                Value: 10,
            },
            {
                Key: "B",
                Value: 19,
            },
            {
                Key: "C",
                Value: 19,
            },
            {
                Key: "D",
                Value: 19,
            },
            {
                Key: "E",
                Value: 19,
            },
            {
                Key: "F",
                Value: 19,
            },
            {
                Key: "G",
                Value: 19,
            },
            {
                Key: "H",
                Value: 19,
            },
            {
                Key: "I",
                Value: 19,
            },
            {
                Key: "J",
                Value: 19,
            },
            ]
            const extention = "Employee_Leaves.xlsx"
            let excelSheetData = []

            postApi("Attendance/emp-leave-list", {
                fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                    dateFilter[0],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                    dateFilter[1],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                AttendanceUserId: (JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" || JSON.parse(localStorage.getItem("authUser")).RoleName == "Master") ? parseInt(userFilter) : JSON.parse(localStorage?.getItem("authUser")).AttendanceUserId,
                Status: parseInt(statusFilter),
                displayStart: displayStart,
                pageSize: 10000,
                searchText: searchText.trim(),
                sortColumn: "",
                sortOrder: "asc",
            }).then(({ data, status }) => {
                if (status === 200) {
                    for (let index = 0; index < data?.EmpLeaveList.length; index++) {
                        let dataObj = {
                            Name: data?.EmpLeaveList[index].Name,
                            IsFullDay: data?.EmpLeaveList[index].IsFullDay ? "Yes" : "No",
                            LeaveHours: (data?.EmpLeaveList[index].LeaveHours),
                            FromDate: data?.EmpLeaveList[index].FromDate == null
                                ? "N/A"
                                : dateFormat(data?.EmpLeaveList[index].FromDate, "dd-MM-yyyy"),
                            ToDate: data?.EmpLeaveList[index].ToDate == null
                                ? "N/A"
                                : dateFormat(data?.EmpLeaveList[index].ToDate, "dd-MM-yyyy"),
                            Remarks: (data?.EmpLeaveList[index].Remarks ? data?.EmpLeaveList[index].Remarks : "N/A"),
                            Status: GetObjByEmployeeLeaveStatus(data?.EmpLeaveList[index].Status)[0]?.Key,
                            CreatedOn: data?.EmpLeaveList[index].CreatedOn == null
                                ? "N/A"
                                : dateFormat(data?.EmpLeaveList[index].CreatedOn, "dd-MM-yyyy"),
                        }
                        excelSheetData.push(dataObj)
                    }
                    var fields = Object.keys(excelSheetData[0]);
                    var sheetData = excelSheetData.map(function (row) {
                        return fields.map(function (fieldName) {
                            return row[fieldName];
                        });
                    });
                    setIsLoading(false)
                    sheetData.unshift(header);
                    exportDataExcel(sheetData, mainTitle, widthObj, extention)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
                setIsLoading(false)
                setScreenLoad(false)
            })

            setIsLoading(false)
        }
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].parent}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                    link={breadcrumbs[pathname].parentLink}
                />
                <Card>
                    <CardBody>
                        <EmployeeLeaveTable
                            columns={columns}
                            data={tableData}
                            isGlobalFilter={true}
                            isAddUserList={true}
                            handleCreateUpdateEmployeeLeave={handleCreateUpdateEmployeeLeave}
                            customPageSize={10}
                            className="custom-header-css"
                            isLoading={isLoading}
                            TotalRecords={totalRecords}
                            pagePerSize={pagePerSize}
                            setDateFilter={setDateFilter}
                            dateFilter={dateFilter}
                            users={users}
                            userFilter={userFilter}
                            setUserFilter={setUserFilter}
                            setdateDisble={setdateDisble}
                            dateDisble={dateDisble}
                            writeDataToExcel={writeDataToExcel}
                            statusFilter={statusFilter}
                            setStatusFilter={setStatusFilter}
                        />
                        {employeeLeaveModal &&
                            <EmployeeLeaveModal
                                modal={employeeLeaveModal}
                                toggle={employeeLeaveToggle}
                                employeeId={(JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" || JSON.parse(localStorage.getItem("authUser")).RoleName == "Master") ? 0 : userId}
                                isEdit={isEdit}
                                editData={editData}
                                EmpLeaveListApi={EmpLeaveListApi}
                            />
                        }
                    </CardBody>
                </Card>
            </div>
        </div>
    )
}
EmployeeLeave.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
    onFilterChange: PropTypes.func,
}

export default EmployeeLeave
